<template>
  <div class="avatar">
    <img :src="$attrs.value">
  </div>
</template>

<script>
export default {
  name: "BlockAvatar"
}
</script>

<style scoped>

</style>
